module.exports = __webpack_public_path__ + "static/img/user-welfare-bg.9d1fd2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/user-welfare-bg.png
// module id = rxBG
// module chunks = 216